import Vue from 'vue';
import VueRouter from 'vue-router';
import _ from 'lodash';
import LoginPage from './pages/Login';
import MainPage from './pages/Main';
import WelecomePage from './pages/Welecome';
import WorkerPage from './pages/Worker';
import OptionParamPage from './pages/OptionParam';
import StockFactorsPage from './pages/StockFactors/Page.vue';
// import StockFactorsTestPage from './pages/StockTestFactors';
// import AdminPage from './pages/Admin';
import AccountInfoPage from './pages/AccountInfo';
import CbondAccountPage from './pages/CbondAccount';
import NoPermPage from './pages/NoPerm';
import Option1Page from './pages/Option1/Page.vue';
import RiskInstrumentPage from './pages/RiskInstrument';
import StrategyPage from './pages/Strategy.vue';
import DashboardPage from './pages/Dashboard';
import PnlMonitorPage from './pages/PnlMonitor.vue';
import LimitUpOrderPage from './pages/LimitUpOrder.vue';
import HKOption from './pages/HKOption/Page.vue';
import HKOptionMarket from './pages/HKOption/PageMarket.vue';
import store from './store';
import {api} from './plugins/api';
import { Perms } from './plugins/perms';
import ToolsApiPage from './components/ToolsApiPage.vue';
import TradeMain from './pages/TradeMain.vue';
import AdminPage from './pages/Admin/Page.vue';
import LendPage from './pages/Lend.vue';
import FTNews from './pages/FTNews.vue';
import MarketDataMap from './pages/MarketDataMap.vue';
import HKProductPnl from './pages/HKProductPnl/Page.vue';
import FeeRatePage from './pages/FeeRate.vue';
import Market from './pages/Market.vue';
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        // component: WelecomePage,
        redirect: '/main',
    },
    {
        path: '/login',
        component: LoginPage,
    },
    {
        path: '/main',
        component: MainPage,
        children: [
            {
                path: '/',
                component: WelecomePage,
            },
            {
                path: 'noperm',
                component: NoPermPage,
            },
            {
                path: 'dashboard',
                component: DashboardPage,
            },
            {
                path: 'marketDataMap',
                component: MarketDataMap,
            },
            {
                path: 'worker',
                perm: 'worker',
                component: WorkerPage,
            },
            {
                path: 'optionParam',
                perm: 'optionParam',
                component: OptionParamPage,
                meta: {
                    keepAlive: true,
                },
            },
            {
                path: 'stockFactors',
                perm: 'taskReport',
                component: StockFactorsPage,
            },
            {
                path: 'ftnews',
                perm: 'ftnews',
                component: FTNews,
            },
            // {
            //     path: 'stockFactorsTest',
            //     perm: 'taskReport',
            //     component: StockFactorsTestPage,
            // },
            // {
            //     path: 'taskReport',
            //     perm: 'taskReport',
            //     component: TaskReportPage
            // },
            {
                path: 'limitUpOrder',
                perm: 'limitUpOrder',
                component: LimitUpOrderPage,
            },
            {
                path: 'hkOption',
                perm: 'hkOption',
                component: HKOption,
            },
            {
                path: 'hkOptionRead',
                perm: 'hkOptionRead',
                component: HKOption,
            },
            {
                path: 'hkProductPnl',
                perm: 'hkProductPnl',
                component: HKProductPnl,
            },
            {
                path: 'hkOptionMarket',
                perm: 'hkOptionMarket',
                component: HKOptionMarket,
            },
            {
                path: 'lend',
                component: LendPage,
            },
            {
                path: 'strat_Option1',
                perm: 'strat_Option1',
                component: Option1Page,
            },
            {
                path: 'accountInfo',
                perm: 'accountInfo',
                component: AccountInfoPage,
            },
            {
                path: 'cbondAccount',
                perm: 'cbondAccount',
                component: CbondAccountPage,
            },
            {
                path: 'riskInstrument',
                perm: 'riskInstrument',
                component: RiskInstrumentPage,
            },
            {
                path: 'strategy',
                perm: 'strategy',
                component: StrategyPage,
            },
            
            {
                path: 'trade',
                component: TradeMain,
            },
            {
                path: 'market',
                component: Market,
            },
            {
                path: 'pnlMonitor',
                perm: 'pnlMonitor',
                component: PnlMonitorPage,
            },
            {
                path: 'toolsDoc',
                perm: 'toolsDoc',
                component: ToolsApiPage,
            },
            {
                path: 'feeRate',
                perm: 'feeRate',
                component: FeeRatePage,
            },
            {
                path: 'admin',
                perm: 'admin',
                component: AdminPage,
            },
        ],
    },
];

const router = new VueRouter({ routes });
router.beforeEach((to, from, next) => {
    let perm = to.perm;
    let me = store.state.user.me;
    
    if (me && perm) {
        if (!me.perms.includes(perm)) {
            return next('/main/noperm');
        }
    }
    next();
    if (to.path.includes('main')) {
        api.request("POST", 'me/route', {
            path: to.path,
        }).then(() => {});

        let p = to.path.replace('/main/', '');
        let pm = _.find(Perms, {value: p});
        let navTitle = pm ? pm.label : p;
        if (p == 'trade') navTitle = '交易系统';
        else if (p == 'folders') navTitle = '文件系统';

        store.commit('user/setNavTitle', navTitle);
        // console.log('path:', p);
        // if (p !== 'trade') {
        // }
    }
    
});

export default router;
